import ExportPDFButton from "./SalesPDFExport.jsx";
export default function Export(props){return <ExportPDFButton {...props} kind="pricegroup"/>;}
